export const dailyCurrentView = s => s.daily.currentView;
export const dailySearchInfo = s => s.daily.searchInfo;
export const clusterReport = s => s.daily.clusterReport;
export const dailySearchParams = s => s.daily.searchParams;



// WEBPACK FOOTER //
// ./src/modules/Statistics/_store/getter.js